module.exports = __webpack_public_path__ + "img/ITsoftware.52e3124d.png";